<template>
  <div>
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <div v-if="upload_progress > -1">
              <b-progress
                :value="upload_progress"
                variant="info"
                striped
                animated
                class="mb-2"
              >
              </b-progress>
            </div>
            <div v-if="file_uploaded">
              <b-row>
                <b-col>
                  <b-link
                    :href="file_uploaded.file"
                    class="font-italic font-weight-bold"
                    target="_blank"
                  >
                    {{ $t("transaction_fileform.download_file_link") }}
                  </b-link>
                </b-col>
                <b-col>
                  <b-button
                    :disabled="disabled"
                    variant="danger"
                    @click="
                      deleteDocument(
                        file_uploaded.uuid
                      )
                    "
                  >
                    <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-form-file
              v-if="
                upload_progress < 0 &&
                  !file_uploaded
              "
              v-model="file_model"
              v-on:input="onFileInput($event)"
              required
              :disabled="disabled"
              :state="file_form_state"
              placeholder=""
              :browse-text="file_browse_text"
            >
            </b-form-file>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "v-transaction-file-form",
  props: {
    documentation_uuid: String,
    organization_uuid: String,
    file_type: Number,
    file_label: String,
    file_browse_text: String,
    file_send_dispatch: String,
    file_delete_dispatch: String,
    file_uploaded: {
      type: Object,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file_model: undefined,
      file_form_state: null,
      upload_progress: -1,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_fileform: {
          browse_text: "Upload file",
          download_file_link: "Review document",
        },
      },
    },
  },
  methods: {
    deleteDocument(document_uuid) {
      this.$store.dispatch(this.file_delete_dispatch, { document_uuid: document_uuid });
    },
    onFileInput(file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("file_original_filename", file.name);
      formData.append("documentation", this.documentation_uuid);
      formData.append("dest_organization", this.organization_uuid);
      formData.append("file_type", this.file_type);
      this.$store.dispatch(this.file_send_dispatch, {
        onUploadProgress: function(progressEvent) {
          this.upload_progress = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        }.bind(this),
        data: formData,
      }).then(
        () => {
          this.upload_progress = -1;
        },
        () => {
          this.upload_progress = -1;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.download-icon {
  color: $corp-color1;
  border: 2px solid $corp-color1;
  width: $input-height;
  height: $input-height;
  border-radius: $input-border-radius;
  padding: 0.4rem;
}
</style>
